/**
 * Convert string to aria string
 *
 * @example if string is : "+33601020304"
 *          this function return  : "+ 3 3 6 0 1 0 2 0 3 0 4 "
 *
 * @param text the text to convert to aria string
 * @returns aria string
 */
export const convertToAriaString = (text?: string): string => {
    if (!text) {
        return "";
    }

    let outputString = "";
    for (const element of text) {
        outputString += element;
        outputString += " ";
    }

    return outputString;
};

export const initFocusOnElement = (element: HTMLElement): void => {
    element.setAttribute("tabindex", "-1");
    element.focus();
    element.removeAttribute("tabindex");
};
